/** Strings for the Centerstage page (Sara's developer handoff, 2026-10-31). */
export const CENTERSTAGE_COPY = {
  title: 'Centerstage',
  description: 'Browse real-life workplace video scenarios, then add them to your lessons.',

  searchLabel: 'Search videos',
  searchPlaceholder: 'Search by title, description, or concept',
  clearSearch: 'Clear search',
  browsePrefix: 'or',
  browseConcepts: 'browse all concepts',
  suggestHeader: 'Concepts',

  allTypes: 'All types',
  typeLabel: 'Video type',
  allSettings: 'All settings',
  settingLabel: 'Video setting',

  categoryRowLabel: 'Concept categories',
  allCategories: 'All',

  chipRowLabel: 'Active filters',
  removeFilter: (value: string) => `Remove ${value} filter`,
  showAll: 'Show all videos',

  resultCount: (total: number) => (total === 1 ? '1 video' : `${total.toLocaleString()} videos`),
  loading: 'Loading videos…',
  loadError: 'The video library could not be loaded.',
  filtersError: 'The library filters could not be loaded.',
  retry: 'Retry',
  showMore: 'Show more',
  loadingMore: 'Loading…',
  emptyTitle: 'No videos match these filters.',
  emptyBody: 'Clear one to see more, or request a video from the content team.',

  closeDialog: 'Close',
  videoId: (id: string) => `ID ${id}`,
  type: 'Type',
  setting: 'Setting',
  concepts: 'Concepts',
  detailLoading: 'Loading video details…',
  detailError: 'The video details could not be loaded.',
  detailMissing: 'This video is no longer in the library.',
  buildLesson: 'Build a lesson around this video',
  buildingLesson: 'Starting the lesson…',
  buildError: 'The lesson could not be started. Try again.',

  conceptsTitle: 'Concepts',
  conceptCount: (count: number) => (count === 1 ? '1 concept' : `${count} concepts`),
  countsLoading: 'Loading video counts…',
  countsError: 'Video counts could not be loaded, so every concept is selectable.',
  noVideosForConcept: (name: string) => `${name} (no videos)`,
} as const;

/** "1:34" from seconds; null when the runtime is unknown. */
export function formatRuntime(seconds: number | undefined): string | null {
  if (seconds === undefined || !Number.isFinite(seconds) || seconds < 0) return null;
  const whole = Math.round(seconds);
  const minutes = Math.floor(whole / 60);
  const rest = String(whole % 60).padStart(2, '0');
  return `${minutes}:${rest}`;
}
